import { LOGIN_COOKIE_NAME } from "@/constants/utils";
import Cookies from "js-cookie";

class JwtService {
	private token: string | null = null;

	constructor () {
		try { 
			const config: any = document.getElementById('config-server-data')?.innerText;	
			this.token = JSON.parse(config)?.NO_LOGIN_APP;
		} catch (err) {}

		if (!this.token) { 
			this.token = Cookies.get(LOGIN_COOKIE_NAME) || null;
		}
	}

	get jwt () {
		return this.token;
	}
}

export default new JwtService();
